<template>
  <div class="px-3 py-1 text-sm text-white uppercase font-bold" :class="backgroundColor">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    stockStatus: {
      required: true,
      type: String
    },
    product: {
      required: false,
      type: Object,
      default: null
    }
  },
  computed: {
    backgroundColor () {
      switch (this.stockStatus) {
        case 'available':
          return 'bg-success'
        case 'out_of_stock':
          return 'bg-red-500'
        default:
          return 'bg-yellow-500'
      }
    },
    text () {
      switch (this.stockStatus) {
        case 'available':
          return this.deliveryText
        case 'out_of_stock':
          return 'Rupture de Stock'
        default:
          return 'Pré-Commande'
      }
    },
    deliveryText () {
      if (!this.product) {
        return 'En Stock'
      }

      const deliveryDate = this.calculateDeliveryDate()
      return `En Stock - Livraison ${deliveryDate}`
    }
  },
  methods: {
    calculateDeliveryDate () {
      // Obtenir le poids du produit (en kg)
      const weight = this.product?.properties?.weight || this.product?.properties?.gross_weight || 0

      // Déterminer le nombre de jours ouvrés nécessaires
      const businessDaysNeeded = weight < 25 ? 2 : 4

      // Date et heure actuelles
      const now = new Date()
      const currentHour = now.getHours()
      const currentMinutes = now.getMinutes()

      // Vérifier si après la clôture (13h30)
      const isAfterCutoff = currentHour > 13 || (currentHour === 13 && currentMinutes >= 30)

      // Date de départ pour le calcul
      let deliveryDate = new Date(now)

      // Si après clôture, commencer le lendemain
      if (isAfterCutoff) {
        deliveryDate.setDate(deliveryDate.getDate() + 1)
      }

      // Ajouter les jours ouvrés
      let addedBusinessDays = 0
      while (addedBusinessDays < businessDaysNeeded) {
        deliveryDate.setDate(deliveryDate.getDate() + 1)
        const dayOfWeek = deliveryDate.getDay()
        // 0 = dimanche, 6 = samedi
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          addedBusinessDays++
        }
      }

      // Formater la date (ex: "lundi 22 décembre")
      return this.formatDeliveryDate(deliveryDate)
    },
    formatDeliveryDate (date) {
      const daysOfWeek = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
      const months = [
        'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
        'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
      ]

      const dayName = daysOfWeek[date.getDay()]
      const dayNumber = date.getDate()
      const monthName = months[date.getMonth()]

      return `${dayName} ${dayNumber} ${monthName}`
    }
  }
}
</script>
